import { createAction, createSlice } from '@reduxjs/toolkit';
import { getDateTime } from '@sda/utils/date';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { ProfileTypes } from '@sda/enums';
import type { PublicReview } from '@sda/interfaces/review';
import type { FetchDataType } from '@sda/sdk/interfaces';

interface ReviewPayload {
  readonly score: number;
  readonly description: string;
  readonly targetProfileId: string;
  readonly targetProfileType: ProfileTypes;
  readonly name: string;
}

interface AddReviewPayload {
  readonly reviews: ReviewPayload[];
  readonly isAudienceReview: boolean;
  readonly otherFeedback?: string;
}

// LISTENERS
export const startFeatureReview = createAction<string>(`${Reducers.REVIEWS}/startFeatureReview`);
export const startAddReviews = createAction<AddReviewPayload>(`${Reducers.REVIEWS}/startAddReviews`);

// REDUCER

export const reviewAdapter = createEntityAdapter<PublicReview & FetchDataType>({
  sortComparer: (a, b) => getDateTime(b.createdAt).toMillis() - getDateTime(a.createdAt).toMillis(),
});

const reviewsSlice = createSlice({
  initialState: reviewAdapter.getInitialState(),
  name: Reducers.REVIEWS,
  reducers: {
    ...extractSharedActions(reviewAdapter),
  },
});

export const {
  updateOne: updateReview, upsertOne: upsertReview, addOne: addReview,
} = reviewsSlice.actions;

export default reviewsSlice.reducer;
